import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import FilterButton from "../../components/Common/FilterButton";
import FeatureList from "../../components/Feature/FeatureList";
import FeatureFormModal from "../../components/Feature/FeatureFormModal";
import ListPagination from "../../components/Common/ListPagination";
import CommonStyles from "../../static/styles/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureActions from "../../store/actions/Feature";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import { isMobile } from "../../utils";

const useStyles = makeStyles((theme) => ({
  actionBar: {
    ...CommonStyles.actionBar,
    "& > button": {
      marginLeft: "20px",
    },
  },
}));

const Feature = (props) => {
  const classes = useStyles();
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.FEATURE];

  const filterFields = ["name", "scope", "status"];

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getFeatureList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getFeatureList(props.activeFilters, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
      case "Edit":
        return (
          <FeatureFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Filter":
        return (
          <FeatureFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getFeatureList({});
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <FeatureViewContainer className="Feature-View container">
      <FlexContainer align="flex-start">
        <Heading>Features</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="featureAddNewBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <FeatureList featureList={props.featureList} handleClick={handleClick} />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </FeatureViewContainer>
  );
};

const FeatureViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { Feature } = state;
  return {
    featureList: Feature.featureList,
    nextPage: Feature.nextPage,
    prevPage: Feature.prevPage,
    activeFilters: Feature.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFeatureList: bindActionCreators(FeatureActions.getFeatureList, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Feature);
